"use client";

import { MonthlyTransactions } from "@/components/portfolio/transactions/MonthlyTransactions";
import { PortfolioEstateAnalyticsPanel } from "@/components/portfolio/portfolio-page/PortfolioEstateAnalyticsPanel";
import { Panel } from "@/components/ui/Panel";

const EstateCardList = () => {
  return (
    <Panel as="section" variant="section" className="w-full">
      <PortfolioEstateAnalyticsPanel />
      <MonthlyTransactions />
    </Panel>
  );
};

export default EstateCardList;
